module.exports = __webpack_public_path__ + "img/buffalo.8448b9af.jpg";